import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

// TODO: separate into individual self-contained style files in their folders instead of having one big file

export const ElementPaddingDiv = styled.div({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
});

export const ElementPaddingHeader = styled.div(({ theme }) => ({
    color: theme.colors.neutral700,
    display: 'flex',
    fontSize: 10,
    fontWeight: 700,
    height: 18,
    justifyContent: 'space-between',
    letterSpacing: 0.5,
    margin: '8px 0',
    textTransform: 'uppercase',
}));

export const PaddingControlsContainer = styled.div(() => ({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignContent: 'space-between',
    marginBottom: 10,
    height: 94,
}));

export const AllPaddingControllersDiv = styled.div({
    display: 'flex',
    justifyContent: 'space-around',
    width: 40,
});

export const DirectionLabel = styled.label(({ theme }) => ({
    color: theme.colors.neutral700,
    letterSpacing: 1,
    fontSize: 10,
    fontWeight: 400,
}));

export const DirectionIcon = styled(FontAwesomeIcon)({
    marginLeft: 6,
    marginTop: 6,
    fontSize: 14,
    fontWeight: 300,
});

export const ChangePaddingIcon = styled(FontAwesomeIcon)(({ theme }) => ({
    color: theme.colors.neutral700,
    cursor: 'pointer',
    fontSize: 12,
    position: 'relative',
}));

export const PaddingIcon = styled.i`
    font-size: 16px;
    color: ${({ theme }) => theme.colors.primary300};
    cursor: pointer;
    &:focus {
        outline: ${({ theme }) => `2px solid ${theme.colors.primary300};`
    }
`;

export const VerticalLine = styled.div`
    border-right: 1px solid #DCDCDC;
`;

export const Div = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const Label = styled.p`
    width: 112px;
    height: 25px;
    color: ${({ theme }) => theme.colors.neutral700};
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 1;
`;

export const LabelSmall = styled.p`
    height: 19px;
    width: 100%;
    color: ${({ theme }) => theme.colors.neutral700};
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.83;
    text-transform: uppercase;
`;

export const UploadButton = styled.label`
    height: 28px;
    width: 85px;
    background-color: ${({ theme }) => theme.colors.primary300};
    color: white;
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-weight: bold;
    font-size: 12px;
    padding-left: 2px;
    padding-right: 2px;
`;
export const SurveyRequiredError = styled.div`
    height: 22px;
    width: 62px;
    background-color: ${({ theme }) => theme.colors.danger300};
    color: white;
    font-size: 14px;
    text-align: center;
    line-height: 22px;
    position: absolute;
    top: 24px;
    right: 0;
`;

export const InputErrorMsg = styled.div`
    color: ${({ theme }) => theme.colors.danger300};
    font-size: 10px;
    font-weight: 600;
    line-height: 13px;
    text-align: left;
    position: absolute;
    bottom: 0;
`;

export const Info = styled.div`
    width: 158px;
    display: inline-flex;
    color: ${({ theme }) => theme.colors.neutral900};
    vertical-align: middle;
    line-height: 10px;
    font-size: 11px;
    font-weight: 600;
`;

export const Icon = styled.i`
    font-size: 15px;
    color: ${({ theme }) => theme.colors.danger300};
    margin-left: 4px;
    margin-bottom: 2px;
    vertical-align: middle;
`;

export const TooltipMsgSpan = styled.span`
    font-weight: bold;
    line-height: 12px;
`;

export const ElementErrorTd = styled.td`
    position: absolute;
    left: -18px;
    top: -18px;
`;
